/**
 * Copy this file from backend.
 */

/**
 * List of valid actions supported by
 * orderModel::toggleState/orderController::changeState
 * @enum {string}
 * @readonly
 */
const OrderChangeStateActions = {
  CLIENT_COMPLETE_PAYMENT: 'client.complete_payment',
  OPS_START_PREP: 'ops.start_prep',
  OPS_DONE_PREP: 'ops.done_prep',
  OPS_MANUAL_PROVISION: 'ops.manual_provision',
  CLIENT_SCHEDULE_DELIVERY: 'client.schedule_delivery',
  DELIVERY_START: 'delivery.start',
  DELIVERY_SUCCESS: 'delivery.success'
}

/**
 * List of valid states used within orderModel::toggleState
 * @enum {string}
 * @readonly
 */
const OrderChangeState = {
  ORDERED: 'ORDERED', // initial state
  PAYMENT_RECEIVED: 'RECEIVED',
  PREPARING: 'PREPARING',
  READY_FOR_DELIVERY: 'READY_FOR_DELIVERY',
  SCHEDULED_FOR_DELIVERY: 'SCHEDULED_FOR_DELIVERY',
  DELIVERY_IN_PROGRESS: 'DELIVERY_IN_PROGRESS',
  DELIVERED: 'DELIVERED'
}

/**
 * Expected request body for `orderController::changeState`.
 * orderNo is available in the route params
 * @typedef {Object} OrderChangeStatePutData
 * @prop {OrderChangeStateActions} action
 * @prop {DeliveryModel} [deliveryDetails]
 */

/**
 * Expected response from `/order/:orderNo` and `/order`
 * @typedef {Object} OrderModel
 * @prop {*} _id
 * @prop {string} orderNo - use this as identifier
 * @prop {*} orgId
 * @prop {string} orgName
 * @prop {string} userName
 * @prop {string} userEmail
 * @prop {{plan: *, quantity: number, name: string,
 *          price: number, data: number, sms: number, voice: number}[]} items
 * @prop {OrderChangeState} status
 * @prop {string} createdAt
 * @prop {string} updatedAt
 * @prop {number} price - TODO: this should be linked to billing
 * @prop {{statusSetAt: string, status: OrderChangeState,
 *          triggeringAction: OrderChangeStateActions}[]} statusHistory
 */

/**
 * Delivery object.
 * @typedef {Object} DeliveryModel
 * @prop {string} address
 * @prop {string} postalCode
 * @prop {string} contactName
 * @prop {string} contactEmail
 * @prop {string} contactNumber
 * @prop {string} deliveryDate
 * @prop {string} deliveryStartTime
 * @prop {string} deliveryEndTime
 * @prop {['PENDING' | 'SUCCESS' | 'FAILED' | 'CANCELLED']} deliveryStatus
 */

/**
 * Supporting typedef for GET /order/:orderNo/provision
 * @typedef {Object} ProvisionPayload
 * @prop {{msisdn: string, iccid: string, serviceInstanceId: string}[]} manualProvision
 */

module.exports = {
  OrderChangeState,
  OrderChangeStateActions
}
